import { checkPointsDTO } from "../../shared/dtos/checkPointsDTO";

export const sortDestinations = (destinations: checkPointsDTO[]) => {
  const arrayCopy = [...destinations];
  return arrayCopy.sort(
    (a, b) =>
      Number(a.requestSequence ?? a.id) - Number(b.requestSequence ?? b.id),
  );
};
